// Where the confirm-address link lands. Spending the token takes a click
// on purpose: mail scanners open links, and a token burned by a robot
// would leave the real person with a dead one. Confirming never signs
// in - the password door is the next step, and says so.

import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { verifyStaffEmail } from "../api/auth";
import { AuthBrand } from "../components/auth/AuthBrand";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";

  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onConfirm() {
    setBusy(true);
    setError(null);
    try {
      const result = await verifyStaffEmail(token);
      if (!result.ok) {
        setError(result.message);
        return;
      }
      setDone(true);
    } catch {
      setError("Could not reach the server. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="auth-page">
      <div className="auth-card">
        <div className="auth-head">
          <AuthBrand />
          <div className="auth-sub">Confirm your email address</div>
        </div>

        {!token ? (
          <>
            <p className="auth-ok">
              This link is missing the part that identifies you. Open it again from the email we
              sent, or request a fresh one by signing in.
            </p>
            <Link className="auth-link-btn" to="/login">
              Back to sign-in
            </Link>
          </>
        ) : done ? (
          <>
            <p role="status" className="auth-ok">
              Address confirmed. Sign in with your password to continue.
            </p>
            <Link className="auth-link-btn" to="/login">
              Go to sign-in
            </Link>
          </>
        ) : (
          <>
            {error ? (
              <div role="alert" className="auth-alert">
                {error}
              </div>
            ) : null}
            <p className="auth-note">
              One click tells us this mailbox is yours. Signing in stays a separate step - the link
              alone opens nothing.
            </p>
            <button type="button" className="auth-submit" disabled={busy} onClick={onConfirm}>
              {busy ? "Confirming..." : "Confirm my address"}
            </button>
            <Link className="auth-link-btn" to="/login">
              Back to sign-in
            </Link>
          </>
        )}
      </div>
    </main>
  );
}
